{ useI18n } = require 'lib/react_utils'

MDGAnswers = ({ answers }) ->
  i18n = useI18n("team:coi")
  <div>
  {_.map answers, (answersGroup) ->
    { title } = _.first(answersGroup)
    <div key={_.str.dasherize title} className="mb-10">
      <b>{title}</b>
      {_.map answersGroup, (answer) ->
        { inputType, value, consent, client, description } = answer
        <div>
          {switch inputType
            when 'textarea', 'incomeType'
              <div>{value}</div>
            when 'checkbox'
              if consent then i18n 'yes' else i18n 'no'
            when 'honorariaType', 'businessType'
              <div>
                <b>{client}</b>: {description}
              </div>
            else
              <div>{value}</div>
          }
        </div>
      }
    </div>
  }
  </div>

module.exports = MDGAnswers
